<div class="modal-header">
  <h5 class="modal-title">Confirmar datos de pago</h5>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>
<ng-container *ngIf="orderData;">
  <div class="modal-body">
    <div class="row my-4">

      <div class="col-4 offset-3">
        <h6 class="fw-bold">
          Numero de Factura:
        </h6>
      </div>
      <div class="col-5">
        <h6>
          {{orderData?.order?.folio}}
        </h6>
      </div>
      <div class="col-4 offset-3">
        <h6 class="fw-bold">
          Monto factura:
        </h6>
      </div>
      <div class="col-5">
        <h6>
          ${{orderData?.order?.amount | currency:'CLP':'':'1.0'}}
        </h6>
      </div>
      <div class="col-4 offset-3">
        <h6 class="fw-bold">
          Número de Nota de Cobro:
        </h6>
      </div>
      <div class="col-5">
        <h6>
          {{orderData?.reference?.folio || '-'}}
        </h6>
      </div>
      <div class="col-4 offset-3">
        <h6 class="fw-bold">
          Monto nota de cobro:
        </h6>
      </div>
      <div class="col-5">
        <h6 *ngIf="orderData?.reference">
          ${{ orderData?.reference?.amount | currency:'CLP':'':'1.0'}}
        </h6>
        <h6 *ngIf="!orderData?.reference">
          -
        </h6>
      </div>
      <div class="col-4 offset-3">
        <h6 class="fw-bold">
          Mes de documentos:
        </h6>
      </div>
      <div class="col-5">
        <h6>
          {{orderData?.order?.month}}
        </h6>
      </div>

    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <div class="dropdown mx-4">
      <button type="button" class="btn btn-primary" id="payments" data-bs-toggle="dropdown"
        aria-expanded="false">Aceptar</button>
      <ul class="dropdown-menu" aria-labelledby="actions">
        <li>
          <a class="dropdown-item" style="white-space: nowrap;" (click)="pay('khipu')">Pagar con Khipu</a>
          <a class="dropdown-item" style="white-space: nowrap;" (click)="pay('transbank')">Pagar con
            Transbank</a>
        </li>
      </ul>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!loading && orderData == null">
  <div class="modal-body">

    <div class="row my-5 text-center">
      <i class="bi bi-exclamation-circle fs-1 mb-4 text-muted"></i>
      <h3 class="fw-normal">No tienes documentos pendientes de pago</h3>
    </div>
  </div>

</ng-container>
